import ConsentStore from './ConsentStore';

const PIXEL_ID = process.env.REACT_APP_PIXEL_ID;

let initialized = false;
let trackingEnabled = false;

const loadPixelScript = () => {
  // Standard Meta Pixel bootstrap snippet, only run once.
  // eslint-disable-next-line no-unused-expressions
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
  // eslint-disable-next-line no-undef
  fbq('init', PIXEL_ID);
};

export const hasInitialized = () => initialized && trackingEnabled && !!window.fbq;

/**
 * Loads the Meta Pixel and enables tracking. Safe to call multiple times.
 * Does nothing if no PIXEL_ID is configured.
 */
export const enablePixel = () => {
  if (!PIXEL_ID) {
    console.warn('No Pixel ID configured, skipping setup');
    return;
  }
  if (!initialized) {
    loadPixelScript();
    initialized = true;
  }
  trackingEnabled = true;
};

/**
 * Disables tracking. The Pixel script cannot be unloaded once injected, but
 * future `track*` calls become no-ops and the marketing cookies are cleared
 * by ConsentStore on revoke.
 */
export const disablePixel = () => {
  trackingEnabled = false;
};

/**
 * Wires the Pixel to ConsentStore. Call once on app startup.
 * Returns an unsubscribe function so callers (e.g. React effects) can
 * tear down the listener on unmount / HMR / StrictMode double-invoke.
 */
export const initPixelConsentBinding = () => {
  if (ConsentStore.getMarketingConsent()) {
    enablePixel();
  }
  return ConsentStore.subscribe((state) => {
    if (state && state.marketing) {
      enablePixel();
    } else {
      disablePixel();
    }
  });
};

/**
 * Tracks a user purchase. No-op when consent has not been granted.
 */
export const trackPayment = (value, currency) => {
  if (!hasInitialized()) {
    return;
  }
  // eslint-disable-next-line no-undef
  fbq('track', 'Purchase', { value, currency });
};
